<ms-event-group
    *ngFor="let group of groups; trackBy: trackGroup"
    [group]="group"
    [grouping]="grouping"
    [sportId]="sport.id"
    [hideFavourites]="hideFavourites"
    (toggle)="groupToggled($event)">
    <ndc-dynamic [ndcDynamicComponent]="leagueStatisticsComponent$ | async" [ndcDynamicInputs]="{ league: group.statistics }" />
</ms-event-group>
